<template>
    <div class="page-top">
    <header id="theme-header" ref="header" class="theme-header"  :class="[{'has-image' : (featuredImage || isFrontPage), 'is-front-page' : isFrontPage}, 'scroll-' + scrollDir ]">
        <div ref="mainbox" class="holder-top">
            <div class="inner container">
                <router-link to="/" >
                    <PageLogo class="page-logo" />
                </router-link>
                <PageMenu />
            </div>
        </div>
    </header>
        <div class="menus-opacity" @click="hideAnyOpenMenu" :aria-hidden="[(searchModalOpen || mainNaviIsOpen )? 'false': 'true']" v-show="(mainNaviIsOpen || searchModalOpen)" />
        <transition name="opacity">
            <SideMenu :aria-hidden="[mainNaviIsOpen ? 'false': 'true']" v-if="firstTriggerMenu && mainNaviIsOpen" />
        </transition>
        <div class="floating-button">
            <div class="container container--large">
                <ColorLink class="red-button-mobile" v-if="wpvue && wpvue.options && wpvue.options.red_menu_button" color="red" :outlined="false" :link="wpvue.options.red_menu_button"/>
            </div>
        </div>
    </div>
</template>

<script>
import PageLogo from '@/components/elements/PageLogo';
import PageMenu from '@/components/elements/PageMenu';
const SideMenu = () => import('@/components/elements/SideMenu');
//const SearchSide = () => import('@/components/elements/SearchSide');
import ColorLink from '@/components/elements/ColorLink'

import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'theme-header',
    data(){
        return {
            firstTriggerMenu : false,
            firstTriggerSearch : false,
            lastScrollTop: 0,
            delta: 50,
            wpvue: window.WPVUE,
            navbarHeight: 0,
            scrollDir: 'back',
        }
    },
    components: {
        PageLogo,
        PageMenu,
        SideMenu,
        //SearchSide,
        ColorLink
    },
    watch:{
        mainNaviIsOpen(v){
            if(!this.firstTriggerMenu){this.firstTriggerMenu = true}
        },
        searchModalOpen(v){
            if(!this.firstTriggerSearch){
                this.firstTriggerSearch = true
            }
        }
    },

    mounted(){
        window.addEventListener('scroll', this.wathScroll)
        this.wathScroll();
        if(this.$refs.mainbox){
            this.navbarHeight = this.$refs.mainbox.getBoundingClientRect().height
            this.delta = this.navbarHeight/3
            this.scrollDir = 'back'
        }
        if(this.$refs.header){
            const headerRect = this.$refs.header.getBoundingClientRect();
            if(headerRect){ this.$refs.header.style.minHeight = headerRect.height+'px' }
        }
    },
    destroyed(){
        window.removeEventListener('scroll', this.wathScroll)
    },
    methods:{
        ...mapMutations([
            'SEARCH_MODAL_CHANGE_STATE',
            'MENU_OPEN_CHANGE_STATE'
        ]),
        wathScroll(){
            const st = window.pageYOffset
            const VM = this

            if(Math.abs(VM.lastScrollTop - st) <= VM.delta) return;
            
/*             console.log('pageYOffset', st)
            console.log('lastScrollTop', VM.lastScrollTop)
            console.log('navbarHeight', VM.lastScrollTop) */

            if (st > VM.lastScrollTop && st > VM.navbarHeight){
                // Scroll Down
                VM.scrollDir = 'down'
                //$('header').removeClass('nav-down').addClass('nav-up');
            } else {
                if(st <=  VM.navbarHeight){
                    VM.scrollDir = 'back'
                }else if((st + window.innerHeight) < document.documentElement.getBoundingClientRect().height) {
/*                     console.log('1', document.documentElement.getBoundingClientRect().height)
                    console.log('2', window.innerHeight)
                    console.log('3', st) */
                    VM.scrollDir = 'up'
                }
            }
            
            VM.lastScrollTop = st;
        },
        hideAnyOpenMenu(){
            if(this.mainNaviIsOpen){ this.MENU_OPEN_CHANGE_STATE(); }
            if(this.searchModalOpen){ this.SEARCH_MODAL_CHANGE_STATE() }
        }
    },
    computed:{
          ...mapGetters([
			'currentPageID',
            'currentPage',
            'featuredImage',
            'currentPostType',
            'isFrontPage',
            'mainNaviIsOpen',
            'searchModalOpen',
            'isArchive'
        ]),
    }
}
</script>

<style lang="scss">
@import "./../assets/vars.scss";
@import "./../assets/mixins.scss";
@import "./../assets/extends.scss";
.show-popup, .popup-open{
    .theme-header{
        z-index: 1;
    }
}

.search-open{
    .curved-top{
        overflow: hidden;   
    }
    .floating-button{
        z-index: 1!important;
    }
}
.theme-header{
    //background: #fff;
    // &.is-front-page{
    // }
    // &.has-image{
    // }
    position: absolute;
    top: 0;
    z-index: 99;
    left: 0;
    right: 0;

    &.scroll-up, &.scroll-down{
        .holder-top{
            position: fixed;
        }
    }
    &.scroll-up, &.scroll-down{
        .holder-top{
            @include mquery($tablet){
            }
            @extend .box-shadow;
            background-color: #fff;
            .menu-btn{
                padding: 4px 15px;
                .txt{
                    font-size: 80%;
                }
                .icon-menu{
                    margin-top: 1px;
                    margin-left: 0px;
                    svg{
                        width: 20px;
                        height: 20px;    
                    }
                }

                
            }
            .social-links{
                a{
                    height: 35px;
                    &:hover{
                        svg{
                            rect{
                                fill: $green;
                            }
                            path{
                                fill: $dark
                            }
                        }
                    }
                }
                svg{
                    width: 35px;
                    height: 35px;
                    rect{
                        fill: $dark;
                    }
                    path{
                        fill: #fff
                    }
                }
                @include mquery($phone){
                    svg{
                        width: 32px;
                        height: 32px;
                    }
			    }
            }
            .page-logo{
                width: 72px;
                height: auto;
                padding: 5px;
                margin-left: 5px;
                @include mquery($tablet){
                    width: 72px * 0.75;
                    //height: 78px * 0.75;   
                }
                @include mquery($phone){
                    //padding: 10px;
                    //margin-left: -10px;
                }
            }
        }
    }
    &.scroll-back{
        //position: relative;
        .holder-top{
            transform: translateY(0%);
        }
    }
    &.scroll-up{
        .holder-top{
            top: 0;
        }
    }
    &.scroll-down{
        .holder-top{
            top: 0;
            transform: translateY(-100%);
        }
    }
    
    
    .holder-top{
        transition: all 0.3s ease-in-out;
        background-color: transparent;
        z-index: 20;
        transform: translateY(0%);
        top: -200px;
        width: 100%;
        .inner{
            display: flex;
            justify-content: space-between;
            align-items: center;
            position:relative;
        }
    }
    .page-logo{
        //background-color: #fff;
        width: auto;
        height: 150px;
        padding: 25px;
        @include mquery($tablet){
            //width: 145px * 0.75;
            height: 157px * 0.75;   
        }
        @include mquery($phone){
            //width: 145px * 0.5;
            height: 157px * 0.5;    
            padding: 10px;
        }
        a{
            display: block;
            line-height: 1;
        }
        img{
            max-height: 100%;
            
        }
    }

}
</style>